import {PrimeIcons} from "primereact/api";
import {isGruppenturnier, TOURNAMENTSYSTEMS} from "../../../../constants/tournamentSystems";

export const BEREICH = {
    UEBERSICHT: "uebersicht",
    SPIELE: "spiele",
    TEILNEHMER: "teilnehmer",
    STATISTIK: "statistik",
    INFOS: "infos",
};

const vorhanden = (wert) => wert !== null && wert !== undefined;

export function isShowPlatzierung(turnierMain) {
    const isNotNew = turnierMain.tournamentstatus !== "neu";
    const system = turnierMain.turniersystem;
    return isNotNew && (system === TOURNAMENTSYSTEMS.GRUPPE_DANN_DKO.id || system === TOURNAMENTSYSTEMS.GRUPPE_DANN_KO.id
        || system === TOURNAMENTSYSTEMS.DOPPELTERKO.id || system === TOURNAMENTSYSTEMS.EINFACHERKO.id
        || system === TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id);
}

/**
 * Liefert die sichtbaren Bereiche mit ihren Unterpunkten. Die Bedingungen entsprechen den Reitern der alten Ansicht.
 * Bereiche ohne Unterpunkte (außer Übersicht und Infos) werden ausgeblendet.
 */
export function ermittleBereiche(wrapper) {
    const t = wrapper.turnierMain;
    const isNeu = t.tournamentstatus === "neu";
    const isLigaspieltag = t.turniersystem === TOURNAMENTSYSTEMS.LIGASPIELTAG.id;

    const spiele = [];
    if (!isNeu) {
        if (isLigaspieltag) {
            spiele.push({id: "ligaspieltaggames", label: "Games"});
        }
        if (t.turniersystem === TOURNAMENTSYSTEMS.ANY_GAMES.id) {
            spiele.push({id: "anygames", label: "Games"});
        }
        if (t.turniersystem === TOURNAMENTSYSTEMS.LIGA.id) {
            spiele.push({id: "ligaspieltage", label: "Spieltage"});
            spiele.push({id: "ligatabelle", label: "Tabelle"});
        }
        if (vorhanden(wrapper.turnierGruppe)) {
            spiele.push({id: "gruppen", label: t.turniersystem === TOURNAMENTSYSTEMS.SCHWEIZERSYSTEM.id ? "Runden" : "Gruppen"});
        }
        if (vorhanden(wrapper.turnierKO)) {
            const bezeichnung = isGruppenturnier(t.turniersystem) ? wrapper.turnierKO.bezeichnung : "KO/DKO";
            spiele.push({id: "baum", label: bezeichnung, farbe: vorhanden(wrapper.turnierSilber) ? "gold" : undefined});
        }
        if (vorhanden(wrapper.turnierSilber)) {
            spiele.push({id: "silberturnier", label: wrapper.turnierSilber.bezeichnung, farbe: "silver"});
        }
        if (vorhanden(wrapper.turnierBronze)) {
            spiele.push({id: "bronzeturnier", label: wrapper.turnierBronze.bezeichnung, farbe: "bronze"});
        }
        // ab zwei KO-Bäumen (z.B. Gold und Silber) können alle Bäume untereinander angezeigt werden
        const anzahlBaeume = [wrapper.turnierKO, wrapper.turnierSilber, wrapper.turnierBronze].filter(vorhanden).length;
        if (anzahlBaeume >= 2) {
            spiele.push({id: "alleBaeume", label: anzahlBaeume === 2 ? "Beide Bäume" : "Alle Bäume", icon: "pi pi-align-justify"});
        }
        if (vorhanden(wrapper.kratzerDto)) {
            spiele.push({id: "kratzergames", label: "Games"});
        }
        // Live steht immer ganz rechts, damit es nicht der vorausgewählte Unterpunkt ist (es wird der erste gewählt)
        if (t.tournamentstatus === "gestartet" && t.scoringWithDarthelfer) {
            spiele.push({id: "live", label: "Live"});
        }
    }

    const teilnehmer = [];
    if (isNeu && !isLigaspieltag) {
        teilnehmer.push({id: "anmeldung", label: "Anmeldung"});
    }
    teilnehmer.push({id: "teilnehmer", label: "Teilnehmer"});

    const statistik = [];
    if (!isNeu) {
        if (t.scoringWithDarthelfer) {
            statistik.push({id: "highlights", label: "Highlights"});
            statistik.push({id: "statistik", label: "Statistik"});
        }
        if (t.edartDetailStatistik) {
            statistik.push({id: "edartstatistik", label: "Statistik"});
        }
    }
    if (isShowPlatzierung(t)) {
        statistik.push({id: "platzierung", label: "Platzierung"});
    }
    if (t.tournamentstatus === "abgeschlossen" && (t.rangliste || vorhanden(t.ranglisteId))) {
        statistik.push({id: "rangliste", label: "Rangliste"});
    }
    // Vergleich und Verlauf am Ende der Aufzählung
    if (!isNeu && t.scoringWithDarthelfer) {
        statistik.push({id: "vergleich", label: "Vergleich"});
        statistik.push({id: "verlauf", label: "Verlauf"});
    }

    return [
        {id: BEREICH.UEBERSICHT, label: "Übersicht", icon: PrimeIcons.HOME, subs: []},
        {id: BEREICH.SPIELE, label: "Spiele", icon: PrimeIcons.TH_LARGE, subs: spiele},
        {id: BEREICH.TEILNEHMER, label: "Teilnehmer", icon: PrimeIcons.USERS, subs: teilnehmer},
        {id: BEREICH.STATISTIK, label: "Statistik", icon: PrimeIcons.CHART_BAR, subs: statistik},
        {id: BEREICH.INFOS, label: "Infos", icon: PrimeIcons.INFO_CIRCLE, subs: []},
    ].filter(bereich => bereich.id === BEREICH.UEBERSICHT || bereich.id === BEREICH.INFOS || bereich.subs.length > 0);
}
